import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function CaReducer(state = initialState.ca, action: any) {
  switch (action.type) {
    case types.SAVE_CA_SUCCESS:
      return action.ca;
    default:
      return state;
  }
}
